import { useState } from "react";
import { useAuthHeader, useAuthUser } from "../../../../Services/Auth/sessionAuth";
import { Button, Form, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Typography } from '@mui/material';
import { Crypter } from "../../../../Functions/Security/Crypter";
import Data from '../../../../Data/Data.json';
import axios from "axios";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import { ParamsIjaraDto, ParamsIjaraCompteGl } from "../../../../Models/ParamsIjarahDto";

const TypeFinancementIjarah = () => {
    const auth = useAuthUser();
    const authHeader = useAuthHeader();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("");
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
    const [paramsIjarahCompteGl, setParamsIjarahCompteGl] = useState<ParamsIjaraCompteGl[]>([]);
    const [Activetabs, SetActivetabs] = useState(false);

    function HandleConsult() {
        setConsulte(false);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false);
        SetActivetabs(true);
    }

    function HandleAjout() {
        form.resetFields();
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSearchGlobal(true);
        setSbmit('add');
    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('modif');
        setSupprime(true);
        SetActivetabs(false);
        setSearchGlobal(true);
    }

    function HandleSupp() {
        setSbmit('supp');
    }

    function HandleAnnul() {
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setParamsIjarahCompteGl([]);
        setFormactve(true);
        setSbmit('');
        SetActivetabs(false);
        setSearchGlobal(false);
    }

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (<span id='x'><UserOutlined /> Type de financement</span>),
            children: <Tab1 etatG={SearchGlobal} form={form} />
        },
        {
            key: '2',
            label: (<span id='x2'><ContactsOutlined /> Interface comptes</span>),
            children: <Tab2 etatG={SearchGlobal} form={form} glRows={paramsIjarahCompteGl} setGlRows={setParamsIjarahCompteGl} />
        },
        {
            key: '3',
            label: (<span id='3'><UserOutlined /> Autorisations</span>),
            children: <Tab3 form={form} />
        }
    ];

    // Dans la fonction consult()
function consult() {
  if (form.getFieldValue("CodeIjara") == null) {
    SweetAlert.fire({ title: "Svp renseigner le Code du type de Ijara", icon: "warning" });
  } else {
    let data = Crypter.encrypt((form.getFieldValue("CodeIjara")));
    if (data.length != 0) {
      setLoading(true);
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadParamsIjarah,
        headers: {
          'CypherCodeIjara': data, // Utiliser 'CypherCodeIjara' au lieu de 'CypherCodeIjarah'
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            console.log("Response from ReadParamsIjarah:", res); // Ajout d'un log pour le débogage
            if (res.StatutCode == 200) {
              // Récupération sécurisée des tables
              const table1 = res.Result.Table1 || [];
              const table2 = res.Result.Table2 || [];
              const table3 = res.Result.Table3 || [];
              const table4 = res.Result.Table4 || [];
              const table5 = res.Result.Table5 || [];
              const table6 = res.Result.Table6 || [];
             

              let ParamsIjarah: ParamsIjaraDto = table1[0] || {};

              ParamsIjarah.CategorieActifsIjara = table2.map((x: any) => x.CodeCategorie);
              ParamsIjarah.PlanRemAuto = table3.map((x: any) => x.IDPLAN);
              ParamsIjarah.Frais = table4.map((x: any) => x.CODOPE);
           
              ParamsIjarah.TypeGarantieAuto = table5.map((x: any) => x.CodeTypeGarantie);

              const paramsIjarahCompteGl: ParamsIjaraCompteGl[] = table6.map((x: any) => ({
                Id: x.CodeAgence,
                CodeAgence: x.CodeAgence,
                CodeIjara: x.CodeIjara,
                CompteImmobilisation: x.CompteImmobilisation,
                CompteProduitLocation: x.CompteProduitLocation,
                CompteDotationAmort: x.CompteDotationAmort,
                CompteAmortissement: x.CompteAmortissement,
                CompteProduitCession: x.CompteProduitCession,
                CompteEncaissementLoyer: x.CompteEncaissementLoyer,
                CompteCharite: x.CompteCharite,
                CompteCreanceLoyerImpayeeGL: x.CompteCreanceLoyerImpayeeGL,
                ComptePromesseOctroiGL: x.ComptePromesseOctroiGL,
                CompteProduitARecevoirLoyerImp: x.CompteProduitARecevoirLoyerImp,
                CompteTVAARecevoirLoyerImp: x.CompteTVAARecevoirLoyerImp,
                CompteTVAPercuLoyer: x.CompteTVAPercuLoyer,
                DateModification: x.DateModification
              }));

              setParamsIjarahCompteGl(paramsIjarahCompteGl);
              form.setFieldsValue(ParamsIjarah);
              HandleConsult();
            } else {
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" });
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: "Error", text: error, icon: "error" });
        });
    }
  }
}

    const onFinish = () => {
        const values = form.getFieldsValue(true);
        var ParamsIjarah: ParamsIjaraDto = values;
        ParamsIjarah.CODUTI = user.coduti;
        ParamsIjarah.CodAge = user.codage;
        ParamsIjarah.ParamsIjaraCompteGl = paramsIjarahCompteGl;

        if (sbmit == "add") {
            SweetAlert.fire({
                title: "Création du Paramètre de financement Ijarah",
                text: "Voulez-vous Créer le Paramètre de financement Ijarah " + ParamsIjarah.LibelleIjara + " ?",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(ParamsIjarah));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateParamsIjarah,
                        headers: {
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                if (res.StatutCode == 200) {
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });
                                    HandleAnnul();
                                } else {
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" });
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error);
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" });
                        });
                }
            });
        }

        if (sbmit == "modif") {
            SweetAlert.fire({
                title: "Mise à jour du Paramètre de financement Ijarah",
                text: "Voulez-vous mettre à jour le Paramètre de financement Ijarah " + ParamsIjarah.CodeIjara + " ?",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(ParamsIjarah));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateParamsIjarah,
                        headers: {
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                if (res.StatutCode == 200) {
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });
                                    HandleAnnul();
                                } else {
                                    SweetAlert.fire({ title: "Warning", text: res.Result, icon: "warning" });
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error);
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" });
                        });
                }
            });
        }
    };

    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        });
        SweetAlert.fire({
            title: "Veuillez remplir tous les champs obligatoires",
            text: errors.toString().replaceAll(',', " - "),
            icon: 'warning',
            confirmButtonText: 'OK'
        });
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veuillez remplir tous les champs", icon: "warning" });
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form
                    preserve={true}
                    disabled={FormAct}
                    autoComplete="off"
                    labelAlign='left'
                    form={form}
                    name="dynamic_form_complex"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    style={{ minWidth: 'auto', maxWidth: 'auto' }}
                >
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult(); }} type="ghost" htmlType="button" block>
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout(); }} type="ghost" htmlType="button" block>
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif(); }} type="ghost" htmlType="button" block>
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp(); }} type="ghost" htmlType="submit" block>
                                    Désactiver
                                </Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul(); }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div>
                                <Tabs size='large' type="card" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
};

export default TypeFinancementIjarah;